import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {TimelineEvent} from "../DB/timelineEvents/@TimelineEvent.js";

const MTClass = TimelineEvent;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddTimelineEvent extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateTimelineEvent extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteTimelineEvent extends Command<{id: string}> {}

//@UserEdit
export class StopCurrentTimelineEvents extends Command<{timelineID: string}> {
	/*subs_eventStops: StopTimelineEvent[];
	Validate() {
		const {timelineID} = this.payload;

		/*const events = GetTimelineEvents(timelineID);
		//let events = GetAsync(()=>GetEvents(timelineID));
		const eventToStopIDs = events.filter(a=>a.endTime == null).map(a=>a.id);*#/
		const ongoingEvents = GetDocs({
			params: {filter: {endTime: {equalTo: null}}},
		}, a=>a.timelineEvents);
		const eventToStopIDs = ongoingEvents.filter(a=>a.timeline == timelineID).map(a=>a.id);

		this.subs_eventStops = eventToStopIDs.map(id=>new StopTimelineEvent({id}).MarkAsSubcommand(this));
		for (const command of this.subs_eventStops) {
			command.Validate();
		}
	}

	DeclareDBUpdates(db: DBHelper) {
		const {timelineID} = this.payload;
		for (const command of this.subs_eventStops) {
			db.add(command.GetDBUpdates(db));
		}
	}*/
}

//@UserEdit
export class StopTimelineEvent extends Command<{id: string}> {
	/*newEndTime: number;
	Validate() {
		AssertValidate({
			properties: {
				id: {type: "string"},
			},
			required: ["id"],
		}, this.payload, `Payload invalid`);

		const {id} = this.payload;
		//const oldData = await GetAsync(()=>GetTimelineEvent(id));
		this.newEndTime = Date.now();

		const oldEndTime = GetTimelineEvent(id)?.endTime;
		AssertV(oldEndTime == null, "Cannot stop an event that is already stopped. (ie. has an end time)");
	}

	DeclareDBUpdates(db: DBHelper) {
		const {id} = this.payload;

		db.set(dbp`timelineEvents/${id}/.endTime`, this.newEndTime);
	}*/
}